import React, {useState} from 'react';

import * as S from './TextInput.styles';

const TextInput = ({
  labelText,
  placeholder,
  haserror,
  classes,
  inputType = 'text',
  endIcon,
  mobileNumber,
  setterObj,
}) => {
  const [fieldType, setFieldType] = useState(inputType);

  const viewPassword = () => setFieldType(fieldType === 'text' ? 'password' : 'text');

  const handleChange = e => {
    setterObj(e.target.value);
  };

  return (
    <S.InputContainer className={classes ? classes : ''}>
      {labelText && <label>{labelText}</label>}
      <S.InputWrapper extrapadding={mobileNumber}>
        {mobileNumber && (
          <S.FlagCont>
            <S.Flag>{/*<img src="https://picsum.photos/200/300" alt="flag" />*/}</S.Flag>
            <S.Code>+971</S.Code>
          </S.FlagCont>
        )}
        {endIcon && <span className={`${endIcon}`} onClick={viewPassword}></span>}
        <input
          type={fieldType}
          onChange={handleChange}
          placeholder={placeholder}
          className={`${haserror ? 'isError' : ''}`}
        />
      </S.InputWrapper>
    </S.InputContainer>
  );
};

export default TextInput;
